import { useState, useEffect } from 'react';
import './index.css';
import Form from './Form.js';
import Todos from './Todos.js';
//
const getLocalStorage = () => {
  let list = localStorage.getItem('todos');
  if (list) {
    return (list = JSON.parse(localStorage.getItem('todos')));
  } else {
    return [];
  }
};

function App() {
  //set state
  const [name, setName] = useState('');
  const [category, setCategory] = useState('food');
  const [todos, setTodos] = useState(getLocalStorage());
  const [isEditing, setIsEditing] = useState(false);
  const [editID, setEditID] = useState(null);
  const [alert, setAlert] = useState({ show: false, msg: '', type: '' });
  const [status, setStatus] = useState('all');
  const [filter, setFilter] = useState([]);

  //functions
  //submit
  const submitHandler = (e) => {
    e.preventDefault();
    if (!name) {
      showAlert(true, 'danger', 'please enter a value');
    } else if (name && isEditing) {
      setTodos(
        todos.map((item) => {
          if (item.id === editID) {
            return { ...item, name, category };
          }
          return item;
        })
      );
      setName('');
      setCategory('food');
      setEditID(null);
      setIsEditing(false);
      showAlert(true, 'success', 'item name changed');
    } else {
      const newItem = {
        id: new Date().getTime().toString(),
        name,
        category,
        completed: false,
      };
      showAlert(true, 'success', 'item added to the list');
      setTodos([...todos, newItem]);
      setName('');
    }
  };
  //alert
  const showAlert = (show = false, type = '', msg = '') => {
    setAlert({ show, type, msg });
  };
  //check
  const checkHandler = (id) => {
    showAlert(true, 'success', 'item completed');

    setTodos(
      todos.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            completed: !item.completed,
          };
        }
        return item;
      })
    );
  };
  //edit
  const editHandler = (id) => {
    let specificItem = todos.find((item) => item.id === id);
    setIsEditing(true);
    setEditID(id);
    setName(specificItem.name);
    setCategory(specificItem.category);
  };
  //delete
  const deleteHandler = (id) => {
    showAlert(true, 'danger', 'item deleted');
    setTodos(todos.filter((item) => item.id !== id));
  };
  //clear all
  const clearHandler = () => {
    showAlert(true, 'danger', 'all items deleted');
    setTodos([]);
  };
  //filter items
  const filterHandler = () => {
    switch (status) {
      case 'completed':
        setFilter(todos.filter((item) => item.completed === true));
        break;
      case 'incompleted':
        setFilter(todos.filter((item) => item.completed === false));
        break;
      case 'clothes':
        setFilter(todos.filter((item) => item.category === 'clothes'));
        break;
      case 'food':
        setFilter(todos.filter((item) => item.category === 'food'));
        break;
      case 'drink':
        setFilter(todos.filter((item) => item.category === 'drink'));
        break;
      case 'entertainment':
        setFilter(todos.filter((item) => item.category === 'entertainment'));
        break;
      default:
        setFilter(todos);
        break;
    }
  };
  //use Effect
  useEffect(() => {
    filterHandler();
  }, [todos, status]);
  //store item in local storage
  useEffect(() => {
    localStorage.setItem('todos', JSON.stringify(todos));
  }, [todos]);
  //return elements
  return (
    //form & todos
    <section className="section-center">
      <Form
        todos={todos}
        submitHandler={submitHandler}
        setName={setName}
        name={name}
        category={category}
        setCategory={setCategory}
        alert={alert}
        showAlert={showAlert}
        status={status}
        setStatus={setStatus}
      />
      <div className="grocery-container">
        <Todos
          checkHandler={checkHandler}
          editHandler={editHandler}
          deleteHandler={deleteHandler}
          filter={filter}
        />
      </div>
      <button className="glow-on-hover clear-btn" onClick={clearHandler}>
        clear items
      </button>
    </section>
  );
}

export default App;
